import { getRequest } from '../../../utils/requests';
import config from '../../../config.json';

const API_BASE_URL = config.service;

// Основной endpoint для получения состояния системы
export const fetchSystemHealthData = async () => {
  try {
    const response = await getRequest(`${API_BASE_URL}/api/system/health`);
    return response.data;
  } catch (error) {
    console.error('Ошибка при получении данных мониторинга:', error);
    throw error;
  }
};

// Получение метрик системы
export const fetchSystemMetrics = async (timeInterval = '30min') => {
  try {
    const response = await getRequest(`${API_BASE_URL}/api/system/metrics?interval=${timeInterval}`);
    return response.data;
  } catch (error) {
    console.error('Ошибка при получении метрик системы:', error);
    throw error;
  }
};

// Получение статуса конкретного модуля
export const fetchModuleStatus = async (moduleName) => {
  try {
    const response = await getRequest(`${API_BASE_URL}/api/system/module/${moduleName}/status`);
    return response.data;
  } catch (error) {
    console.error(`Ошибка при получении статуса модуля ${moduleName}:`, error);
    throw error;
  }
};

// Получение логов ошибок
export const fetchErrorLogs = async (moduleName, limit = 100) => {
  try {
    const response = await getRequest(`${API_BASE_URL}/api/system/errors?module=${moduleName}&limit=${limit}`);
    return response.data;
  } catch (error) {
    console.error(`Ошибка при получении логов ошибок для модуля ${moduleName}:`, error);
    throw error;
  }
};

// Новые endpoints для статистики заказов
export const fetchCompletedOrdersStats = async (period = '30days') => {
  try {
    const response = await getRequest(`${API_BASE_URL}/api/system/completed-orders/stats?period=${period}`);
    return response.data;
  } catch (error) {
    console.error('Ошибка при получении статистики завершенных заказов:', error);
    throw error;
  }
};

// Получение разбивки заказов по статусам
export const fetchOrdersStatusBreakdown = async () => {
  try {
    const response = await getRequest(`${API_BASE_URL}/api/system/orders/status-breakdown`);
    return response.data;
  } catch (error) {
    console.error('Ошибка при получении разбивки заказов по статусам:', error);
    throw error;
  }
};

// Получение проблемных заказов
export const fetchOrdersIssues = async () => {
  try {
    const response = await getRequest(`${API_BASE_URL}/api/system/orders/issues`);
    return response.data;
  } catch (error) {
    console.error('Ошибка при получении проблемных заказов:', error);
    throw error;
  }
}; 